<style lang="scss">
.filter-col {
  margin-bottom: 5px;
  margin-top: 0;
  padding-bottom: 5px;
  padding-top: 0;
}
</style>
<template>
  <v-container fluid>
    <v-card class="mb-5">
      <v-toolbar @click="showFilters = !showFilters" flat>
        <v-toolbar-title class="grey--text" v-if="!search">
          Filtros
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn v-if="showFilters" icon>
          <v-icon>mdi-chevron-up</v-icon>
        </v-btn>
        <v-btn v-else icon>
          <v-icon>mdi-chevron-down</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>

      <v-card-text v-if="showFilters">
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              label="Número"
              outlined
              dense
              hide-details
              single-line
              v-model="advanced_filters.numero"
              @keyup.enter="handleFilter()"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <ClientPicker
              hide-details
              outlined
              dense
              prepend_inner_icon=""
              single_response
              label="Cliente"
              v-model="advanced_filters.cliente"
              @keyup.enter="handleFilter()"
              single-line
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-autocomplete
              label="Vendedor"
              :items="users"
              item-text="name"
              item-value="id"
              outlined
              dense
              hide-details
              clearable
              single-line
              v-model="advanced_filters.vendedor"
              @keyup.enter="handleFilter()"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" md="6">
            <DatePicker
              label="Data de criação"
              outlined
              dense
              single-line
              hide-details
              v-model="advanced_filters.data_criacao"
              @keyup.enter="handleFilter()"
              clearable
              prepend-icon=""
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-select
              label="Total"
              outlined
              dense
              hide-details
              single-line
              :items="total_options"
              v-model="advanced_filters.total_venda"
              @keyup.enter="handleFilter()"
            ></v-select>
          </v-col>
          <v-col cols="12" md="6">
            <v-select
              label="Statuses"
              outlined
              dense
              hide-details
              single-line
              :items="statuses"
              multiple
              v-model="advanced_filters.statuses"
            >
              <template v-slot:selection="{ item, index }">
                <v-chip small v-if="index === 0">
                  <span>{{ item.text }}</span>
                </v-chip>
                <span v-if="index === 1" class="grey--text caption">
                  (+{{ advanced_filters.statuses.length - 1 }})
                </span>
              </template>
            </v-select>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-btn @click="handleFilter()" color="primary">
          <v-icon small class="pr-2">mdi-filter</v-icon>
          Filtrar
        </v-btn>
        <v-btn @click="resetAdvancedFilters()" text>
          <v-icon small class="pr-2">mdi-filter-off</v-icon>
          Limpar
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
    <v-card>
      <v-toolbar flat>
        <v-toolbar-title class="grey--text" v-if="!search">
          Pedidos
        </v-toolbar-title>

        <v-spacer v-if="!search"></v-spacer>
        <v-btn @click="createSale()" color="red" class="ml-1" dark>
          <v-icon class="pr-2">mdi-cart</v-icon>
          Vender
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col cols="12" lg="4">
            <v-text-field
              light
              prepend-inner-icon="mdi-magnify"
              label="Pesquisar Pedido"
              v-model="filter"
              hide-details
              single-line
              @keyup.enter="handleFilter()"
              ref="filter"
              :disabled="loading"
              class="mr-3"
              clearable
              @click:clear="handleClearFilter"
            >
            </v-text-field>
          </v-col>
          <v-col class="text-right"> </v-col>
        </v-row>
      </v-card-text>
      <v-data-table
        :loading="loading"
        :items="items"
        :options.sync="options"
        :server-items-length="total_items"
        :headers="headers"
        hide-default-footer
        class="py-5"
        mobile-breakpoint="960"
      >
        <template v-slot:item.numero="{ item }">
          <router-link
            :to="{
              name: 'edit_pedido',
              params: { numero: item.numero }
            }"
          >
            {{ item.numero }}
          </router-link>
        </template>
        <template v-slot:item.status_description="{ item }">
          <v-chip
            :color="getStatusColor(item.status).color"
            :dark="getStatusColor(item.status).dark"
            label
            small
          >
            {{ item.status_description }}
          </v-chip>
        </template>
        <template v-slot:item.created_at="{ item }">
          {{ formatDateTime(item.created_at) }}
        </template>
        <template v-slot:item.total_venda="{ item }">
          {{ formatMoney(item.total_venda) }}
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn
            :to="{
              name: 'edit_pedido',
              params: { numero: item.numero }
            }"
            icon
            color="primary"
          >
            <v-icon> mdi-open-in-new </v-icon>
          </v-btn>
        </template>
        <template v-slot:footer="{ props, on }">
          <v-data-footer
            v-bind="props"
            v-on="on"
            :items-per-page-options="[5, 10, 15, 20]"
          />
        </template>
      </v-data-table>
    </v-card>

    <confirm-action-dialog
      :confirm_action="confirm_cancelation"
      @change="confirm_cancelation = $event"
      @action="updateCancelation"
      :message="
        cancelation_sale.cancelado
          ? 'Este pedido será cancelado.'
          : 'Este pedido será reaberto.'
      "
    />
  </v-container>
</template>

<script>
import ConfirmActionDialog from "@/components/ConfirmActionDialog";
import { index, cancel, approve } from "@/services/sales";
import { format as formatMoney } from "@/utils/money";
import { formatDate } from "@/utils/date";
import ClientPicker from "@/components/ClientPicker";
import DatePicker from "@/components/tools/DatePicker";
import DateTimeMixin from "@/mixins/DateTimeMixin";

export default {
  mixins: [DateTimeMixin],
  components: { ConfirmActionDialog, ClientPicker, DatePicker },
  data: () => ({
    showFilters: false,
    items: [],
    users: [],
    loading: false,
    options: {
      itemsPerPage: 10,
      sortBy: ["numero"],
      sortDesc: [true]
    },
    filter: "",
    total_items: 0,
    headers: [
      { text: "Número", value: "numero", width: 150 },
      { text: "Cliente", value: "cliente_nome" },
      { text: "Vendedor", value: "vendedor_nome" },
      { text: "Data da Venda", value: "created_at", width: 200 },
      { text: "Total da Venda", value: "total_venda", width: 180 },
      { text: "Status", value: "status_description", width: 150 },
      {
        text: "",
        value: "actions",
        align: "center",
        sortable: false,
        width: 60
      }
    ],
    search: false,
    confirm_cancelation: false,
    cancelation_sale: {},
    statuses: [
      { text: "Em aberto", value: "em_aberto" },
      { text: "Em aprovacao", value: "em_aprovacao" },
      { text: "Aprovado", value: "aprovado" },
      { text: "Recusado", value: "recusado" },
      { text: "Finalizado", value: "finalizado" },
      { text: "Cancelado", value: "cancelado" }
    ],
    advanced_filters: {},
    total_options: [
      {
        text: "Todos",
        value: null
      },
      {
        text: "até R$ 100,00",
        value: {
          from: 0,
          to: 100
        }
      },
      {
        text: "até R$ 500,00",
        value: {
          from: 0,
          to: 500
        }
      },
      {
        text: "até R$ 1.000,00",
        value: {
          from: 0,
          to: 1000
        }
      },
      {
        text: "> R$ 1.000,00",
        value: {
          from: 1000,
          to: null
        }
      }
    ]
  }),
  methods: {
    handleFilter() {
      localStorage.setItem(
        "sales_advanced_filters",
        JSON.stringify(this.advanced_filters)
      );
      this.options.page = 1;
      this.fetchSales();
    },
    indexUsers() {
      const { sortBy, sortDesc, page, itemsPerPage } = {
        sortBy: ["name"],
        sortDesc: [false],
        page: 1,
        itemsPerPage: 99
      };

      return this.$http.get(
        `/users?&page=${page}&perPage=${itemsPerPage}&orderBy=${
          sortBy[0] ? sortBy[0] : ""
        }&sortDesc=${sortDesc[0] ? sortDesc[0] : ""}&filter=${this.filter}`
      );
    },
    async getUsers() {
      this.loading = true;
      this.users = [];
      const response = await this.indexUsers();
      const data = response.data;
      this.users = data.data;
      this.loading = false;
    },
    resetAdvancedFilters() {
      this.advanced_filters = {};
      localStorage.removeItem("sales_advanced_filters");
      this.fetchSales();
    },
    getStatusColor(status) {
      switch (status) {
        case "em_aberto":
          return {};
        case "cancelado":
          return { color: "red", dark: true };
        case "finalizado":
          return { color: "green", dark: true };
        case "em_aprovacao":
          return { color: "orange", dark: true };
        case "aprovado":
          return { color: "green", dark: true };
        case "recusado":
          return { color: "red", dark: true };
      }
    },
    createSale() {
      this.$router.push({ name: "new_pedido" });
    },
    async fetchSales() {
      this.loading = true;
      try {
        this.items = [];
        const response = await index(
          this.options,
          this.filter,
          this.advanced_filters
        );

        this.items = response.data;
        this.total_items = response.total;
      } catch (error) {
        this.$store.commit("sendMessage", {
          text: "Falha ao carregar pedidos",
          color: "red"
        });
      } finally {
        this.loading = false;
      }
    },
    handleClearFilter() {
      this.search = false;

      if (this.filter) {
        this.filter = "";
        this.options.page = 1;
        this.fetchSales();
      }
    },
    formatDate(value) {
      const date = new Date(value);
      return value ? formatDate(date) : "";
    },
    formatMoney(value) {
      const money = Number(value || 0);
      return formatMoney(money);
    },
    confirmUpdateCancelation(sale, cancelado) {
      this.confirm_cancelation = true;
      this.cancelation_sale = {
        id: sale.id,
        cancelado
      };
    },
    async updateCancelation() {
      try {
        await cancel(this.cancelation_sale.id, {
          cancelado: this.cancelation_sale.cancelado
        });
        this.fetchSales();
      } catch (e) {
        this.$store.commit("sendMessage", {
          text: "Falha ao cancelar pedido",
          color: "red"
        });
      } finally {
        this.confirm_cancelation = false;
        this.cancelation_sale = {};
      }
    },
    async updateApproval(sale) {
      try {
        await approve(sale.id, {
          aprovado: true
        });
        this.fetchSales();
      } catch (e) {
        this.$store.commit("sendMessage", {
          text: "Falha ao aprovar pedido",
          color: "red"
        });
      }
    }
  },
  computed: {
    user() {
      return this.$store.getters.getUser;
    }
  },
  watch: {
    options: {
      handler() {
        this.fetchSales();
      },
      deep: true
    }
  },
  created() {
    this.getUsers();

    const raw_storage_filters = localStorage.getItem("sales_advanced_filters");
    if (raw_storage_filters) {
      const storage_filters = JSON.parse(raw_storage_filters);
      this.advanced_filters = storage_filters;
    }
  },
  mounted() {}
};
</script>
